import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1eb53b62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "GraphMatchRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = {
  class: "bothCenter mt28"
};
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col mt24"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_GraphMatchMatrix = _resolveComponent("GraphMatchMatrix");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16 bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "选择可以与图例补成 " + _toDisplayString($options.gridSize) + "x" + _toDisplayString($options.gridSize) + " 正方形的选项（包括旋转后）", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt20 bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_GraphMatchMatrix, {
      matrix: $props.data.stem,
      size: $options.gridSize,
      "fill-color": "#ef233c"
    }, null, 8, ["matrix", "size"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: $options.optionIds,
    "option-width": "140px",
    "option-both-center": false,
    key: `GraphMatch_${$props.data.questionIndex}`
  }, {
    default: _withCtx(btnIndex => [_createVNode(_component_GraphMatchMatrix, {
      matrix: $options.optionAt(btnIndex.index).matrix,
      size: $options.gridSize,
      "fill-color": "#0077b6"
    }, null, 8, ["matrix", "size"])]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode", "options"]))]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($options.correctAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: _normalizeStyle({
      color: $props.review.result ? 'green' : 'red'
    })
  }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}